import React, { useState } from "react";
import "./style.scss";
import ButtonCustom from "../Button";
import CheckboxCustom from "../Checkbox";

type Props = {
  label?: string | JSX.Element;
  icon?: JSX.Element;
  listCheckBox: any;
  onChange: any;
  reverseText?: any;
  rowClassName?: string;
  menuTitle?: string;
  disabled?: boolean;
};

const DropdownWithCheckboxMenu = ({
  label,
  icon = <></>,
  listCheckBox,
  onChange,
  reverseText = true,
  rowClassName = "",
  menuTitle,
  disabled,
}: Props) => {
  const [open, setOpen] = useState(false);

  const menu = listCheckBox.map((checkbox: any, index: number) => {
    return (
      <div
        key={index}
        className={"dropdown-with-checkbox__row " + rowClassName}
      >
        <CheckboxCustom
          disabled={disabled}
          checked={checkbox?.checked}
          value={checkbox?.id}
          onChange={onChange}
          reverseText={reverseText}
          label={checkbox?.name}
        />
      </div>
    );
  });

  return (
    <div className={"dropdown-with-checkbox"}>
      <ButtonCustom
        height={"44px"}
        className={"filter " + (open ? "show" : "")}
        onClick={() => setOpen(!open)}
      >
        <span className={"mr-10px text"}>{label}</span>
        {icon}
      </ButtonCustom>
      {open ? (
        <>
          <div
            className={"dropdown-with-checkbox__overlay"}
            onClick={() => setOpen(false)}
          />
          <div className={"dropdown-with-checkbox__menu"}>
            {menuTitle ? (
              <div className={"dropdown-with-checkbox__title"}>{menuTitle}</div>
            ) : null}

            {menu}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default DropdownWithCheckboxMenu;
